import { useParams } from "react-router";

import { ReviewCards } from "@/components/Review/ReviewCards";

interface ReviewProps {
  mode: "all" | "scheduled" | "missed";
}

export const Review = ({ mode }: ReviewProps) => {
  const { deckId } = useParams();

  // ReviewCards keeps track of responses in a local setState variable so it can show accurate progress.
  // Setting "key" here ensures that this cache is reset if the deck or mode changes.
  return <ReviewCards maybeDeckId={deckId} mode={mode} key={`${deckId}-${mode}`} />;
};
